import { createContext } from "react"

const Context = createContext({
  mainLang: "",
  changeMainLang: () => {},
  pathname: "/",
})

export default Context
